var app = angular.module("leonardo");

var ReportsWorkflowListFilters = function(
  $scope,
  $state,
  $controller,
  $timeout,
  $rootScope,
  ReportService,
  WorkFlowService,
  UnitService,
  UnitTypeService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersWorkFlow;

  $scope.by_unit = !!$state.current.by_unit;

  $scope.group_options.push({ id: 'user_role', name: 'User Role' });
  $scope.group_options.push({ id: 'managed_by', name: 'Managed By' });

  $scope.filters_options = [];
  $scope.unit_report_types = [];

  $scope.initOptions = function() {
    if ($scope.by_unit){
      $scope.unit_report_types = ReportService.REPORT_UNIT_TYPES;
    }
    else {
      $scope.unit_report_types = [];
      angular.forEach(ReportService.REPORT_UNIT_TYPES, function(value){
        if (value.id !== ReportService.REPORT_TYPE_UNIT_TYPE) {
          $scope.unit_report_types.push(value);
        }
      });
    }
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'name',
        name: $scope.by_unit ? 'Name Unit Workflow' : 'Name Workflow',
        label: $scope.by_unit ? 'Name Unit Workflow Contains' : 'Name Workflow Contains',
        inline: false,
        type: 'text',
        placeholder: $scope.by_unit ? 'Name Unit Workflow' : 'Name Workflow',
        condition: true,
        conflicts: ['workflow'],
        onSubmit: $scope.display
      },
      {
        id: 'with_deleted',
        name: 'Include Deleted Items',
        label: 'Include Deleted Items',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'workflow',
        name: $scope.by_unit ? 'Unit Workflow' : 'Workflow',
        label: $scope.by_unit ? 'Unit Workflow' : 'Workflow',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: $scope.by_unit ? 'Select Unit Workflow' : 'Select Workflow',
        condition: true,
        service: WorkFlowService,
        serviceParams: {by_unit: $scope.by_unit},
        conflicts: ['name']
      },
      {
        id: 'unit',
        name: 'Unit',
        label: 'Unit',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Unit',
        condition: $scope.by_unit,
        service: UnitService,
        conflicts: ['unit__unit_type']
      },
      {
        id: 'unit__unit_type',
        name: 'Unit Type',
        label: 'Unit Type',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Unit Type',
        condition: $scope.by_unit,
        service: UnitTypeService,
        conflicts: ['unit']
      },
      {
        id: 'unit_report_type',
        name: 'Report Type',
        label: 'Report Type',
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'Select Report Type',
        condition: true,
        required: true,
        options: $scope.unit_report_types,
        conflicts: []
      },
      {
        id: 'by_unit',
        name: 'Is Unit',
        label: 'Is Unit',
        inline: false,
        type: 'checkbox',
        condition: false,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  if ($scope.filters_name !== 'filters_report') {
    var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];

    if (!angular.isArray(filters)) {
      filters = filters.split(',');
    }

    angular.forEach($scope.filterService.filters, function(value, key) {
      if (!_.contains(filters, key) && $scope.isValid(key)) {
        filters.push(key);
      }
    });

    if (!$scope.filterService.hasFilter('unit_report_type')) {
      $scope.filterService.setFilter('unit_report_type', 1, true);
      if (!_.contains(filters,'unit_report_type')) {
        filters.unshift('unit_report_type');
      }
    }

    if (!$scope.filterService.hasFilter('is_unit_turn')) {
      $scope.filterService.setFilter('is_unit_turn', ($scope.by_unit ? 'true' : 'false'));
      if (!_.contains(filters,'is_unit_turn')) {
        filters.push('is_unit_turn');
      }
    }

    $scope.filterService.setFilter($scope.filters_name, filters, true);
    $rootScope.$broadcast('filters-report:initialized');
  }

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', $scope.by_unit ? ReportService.TYPE_UNIT : ReportService.TYPE_WORKFLOW);
  }, 100);

};

app.controller('ReportsWorkflowListFilters', [
  '$scope',
  '$state',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  'WorkFlowService',
  'UnitService',
  'UnitTypeService',
  ReportsWorkflowListFilters
]);
